module.exports = __webpack_public_path__ + "img/fa.f6903c10.svg";